import { toast } from 'react-toastify';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { useLocale } from '../use-locale.hook';

export const usePin = ({ companyId }: { companyId: string }) => {
  const { messagesLocale } = useLocale();
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_EVENTS);
  const { mutate: pinEvent } = useIdempotentAppMutation([QueryKey.PIN_EVENT, companyId], {
    mutationFn: ({ eventId, pinState }: { eventId: string; pinState: boolean }, { headers }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'events', eventId, 'pin'],
        },
        { queryParams: { pinState }, headers },
      ),
    onSuccess: () => {
      toast.success(messagesLocale['EVENT_SUCCESSFULLY_UPDATED']);
      invalidateQuery();
    },
  });

  return {
    pinEvent,
  };
};
